import {
  BottomSide,
  CenteredContent,
  CenteredObject,
  MainWrapper,
  SlideContent,
  SlideHolder,
  SlideShowSide,
} from "./style";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Button } from "../../reuseableComp.tsx/Button";
import { useNavigate } from "react-router-dom";

const OnboardingComp = () => {
  const navigate = useNavigate();

  const handleTosignup = () => {
    navigate("/signup");
  };

  const handleLogin = () => {
    navigate("/login");
  };
  //   const slideData = [
  //     {
  //       image: "/image/lock.png",
  //       h2text: "Private and Secure",
  //       ptext: "The world’s most <b>private</b> messaging app.",
  //     },
  //     {
  //       image: "/image/images1.png",
  //       h2text: "Share with comfort",
  //       ptext: "Share Picture <b>Seamlessly</b>.",
  //     },
  //     {
  //       image: "/image/securedmessage.png",
  //       h2text: "Message Erased",
  //       ptext: "You control when messages are <b>deleted</b>.",
  //     },
  //   ];

  return (
    <>
      <MainWrapper>
        <CenteredObject>
          <CenteredContent>
            <SlideShowSide>
              <SlideContent>
                <Carousel
                  showIndicators={false}
                  autoPlay
                  showStatus={false}
                  showThumbs={false}
                  infiniteLoop={true}
                >
                  <SlideHolder>
                    <div>
                      <img src="/image/lock.png" />
                    </div>
                    <div>
                      <h2>Private & Secure</h2>
                    </div>
                    <div>
                      <p>
                        The world’s most <b>private</b> messaging app.
                      </p>
                    </div>
                  </SlideHolder>

                  <SlideHolder>
                    <div>
                      <img src="/image/images1.png" />
                    </div>
                    <div>
                      <h2>Share with comfort</h2>
                    </div>
                    <div>
                      <p>
                        Share Picture <b>Seamlessly</b>.
                      </p>
                    </div>
                  </SlideHolder>

                  <SlideHolder>
                    <div>
                      <img src="/image/securedmessage.png" />
                    </div>
                    <div>
                      <h2>Message Erased</h2>
                    </div>
                    <div>
                      <p>
                        You control when messages are <b>deleted</b>.
                      </p>
                    </div>
                  </SlideHolder>
                </Carousel>
              </SlideContent>
            </SlideShowSide>
            <BottomSide>
              <Button onClick={handleTosignup}>Get Started</Button>
              <Button onClick={handleLogin}>Sign In</Button>
            </BottomSide>
          </CenteredContent>
        </CenteredObject>
      </MainWrapper>
    </>
  );
};

export default OnboardingComp;
